import { gql } from '@apollo/client';

export const GET_USER_GROUPS = gql`
  query GetUserGroups($skip: Int!, $take: Int!, $searchQuery: String!, $organizationId: String!) {
    getUserGroups(
      UserGroupsInput: {
        skip: $skip
        take: $take
        searchQuery: $searchQuery
        organizationId: $organizationId
      }
    ) {
      totalClientCount
      groupList {
        id
        name
        modules {
          id
          name
          description
          UserPermissions {
            id
            permissionCode
          }
        }
        coaches {
          id
          firstName
          lastName
          profilePic
        }
        clients {
          id
          firstName
          lastName
          profilePic
        }
      }
    }
  }
`;

export const DELETE_USER_GROUP_MUTATION = gql`
  mutation RemoveUserGroup($id: String!) {
    removeUserGroup(id: $id) {
      message
      success
      statusCode
    }
  }
`;

export const GET_ALL_MODULES = gql`
  query {
    getModuleWithPermissions {
      id
      name
      description
      UserPermissions {
        id
        permissionCode
        description
      }
    }
  }
`;

export const CREATE_USER_GROUP = gql`
  mutation CreateUserGroup($input: CreateUserGroupInput!) {
    createUserGroup(createUserGroupInput: $input) {
      id
      name
    }
  }
`;

export const UPDATE_USER_GROUP = gql`
  mutation UpdateUserGroup($input: UpdateUserGroupInput!) {
    updateUserGroup(updateUserGroupInput: $input) {
      message
      statusCode
      success
    }
  }
`;

export const GET_ALL_CLIENTS_COACHES = gql`
  query GetCoachedWithClients($organizationId: String!, $filterText: String!) {
    getCoachedWithClients(organizationId: $organizationId, filterText: $filterText) {
      coaches {
        firstName
        lastName
        id
        userGroupId
        profilePic
      }
      clients {
        firstName
        lastName
        id
        userGroupId
        profilePic
      }
    }
  }
`;

export const ADD_REMOVE_MEMBERS = gql`
  mutation UpdateUserGroupAssignedUsers(
    $groupId: String!
    $coachIds: [String!]!
    $clientIds: [String!]!
  ) {
    updateUserGroupAssignedUsers(
      updateUserGroupUsersInput: { id: $groupId, coachIds: $coachIds, clientIds: $clientIds }
    ) {
      id
      name
      active
      archived
      visible
      createdAt
      updatedAt
      createdBy
    }
  }
`;

export default GET_USER_GROUPS;
